import styled from 'styled-components';
import { media } from 'helpers/breakpoints';

export const ListContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-column-gap: ${({ theme }) => theme.spacing.L40};
  margin-bottom: ${({ theme }) => theme.spacing.M16};
  ${media.medium} {
    grid-template-columns: 1fr 1fr;
  }
`;

export const ListItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.M16};
  padding: ${({ theme }) => theme.spacing.M16} 0;
  ${({ theme }) => theme.fontSize.M16};
  border-bottom: 1px solid ${({ theme }) => theme.colors.GREY_LIGHT};
  &:last-child {
    border-bottom: none;
  }
  &:first-child {
    padding-top: 0;
  }
  ${media.medium} {
    &:nth-last-child(-n + 2) {
      border-bottom: none;
    }
    &:nth-child(-n + 2) {
      padding-top: 0;
    }
  }
`;

export const ListItemNameContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.S8};
`;

export const ListItemName = styled.p`
  text-wrap: nowrap;
`;

export const ListItemValue = styled.p`
  color: ${({ theme }) => theme.colors.GREY_DARKER};
  font-weight: bold;
  text-align: right;
`;

export const ListItemLeadingIcon = styled.div`
  display: flex;
  width: 24px;
  height: 24px;
  color: ${({ theme }) => theme.colors.GREY_DARK};
`;

export const ListItemValueContainer = styled.div`
  display: flex;
  gap: 0 ${({ theme }) => theme.spacing.S8};
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: baseline;
`;
